import React, { useRef, useState } from 'react';
import { timezones } from '../../services/models/timezones';
import { Modal } from '../ui';

interface UpdateTimezoneDialogProps {
  isOpen: boolean;
  timezone: string;
  onClose: () => void;
  onSave: (timezone: string) => void;
}

export default function UpdateTimezoneDialog(props: UpdateTimezoneDialogProps) {
  const [tz, setTz] = useState(props.timezone);

  const cancelButtonRef = useRef(null);

  const handleOnCancel = () => {
    setTz(props.timezone);
    props.onClose();
  };

  const handleSave = () => {
    props.onSave(tz);
    props.onClose();
  };

  const handleTimezoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setTz(value);
  };

  return (
    <Modal isOpen={props.isOpen} onClose={handleOnCancel} initialFocus={cancelButtonRef}>
      <div className="sm:flex sm:items-start">
        <h3 className="text-lg leading-6 font-medium text-gray-900">Update your Timezone</h3>
        <div className="mt-2 max-w-xl text-sm text-gray-500">
          <p>Change the timezone you want associated with your account.</p>
        </div>

        <div className="space-y-6 mt-3">
          <div>
            <label htmlFor="Timezone" className="block text-sm font-medium text-gray-700">
              Timezone
            </label>
            <div className="mt-1">
              <select
                id="Timezone"
                name="Timezone"
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-hidden focus:ring-secondary focus:border-secondary sm:text-sm rounded-md"
                value={tz}
                onChange={(e: any) => handleTimezoneChange(e)}
              >
                {Object.keys(timezones).map(x => (
                  <option key={x} value={x}>
                    {timezones[x]}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="space-y-1">
          <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              className="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-xs font-medium rounded-md text-white bg-secondary hover:bg-secondary-dark focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-secondary sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50"
              onClick={handleSave}
            >
              Save
            </button>
            <button
              type="button"
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-xs px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-secondary sm:mt-0 sm:w-auto sm:text-sm"
              onClick={handleOnCancel}
              ref={cancelButtonRef}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
